import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import StorageIcon from "@mui/icons-material/Storage";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import CategoryIcon from "@mui/icons-material/Category";
import WorkIcon from "@mui/icons-material/Work";
import ApprovalIcon from "@mui/icons-material/Approval";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InventoryIcon from "@mui/icons-material/Inventory";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from '@mui/icons-material/Language';

export const adminActionItems = [
  {
    id: "DASHBOARD",
    title: "Dashboard",
    sideNavTitle: "Dashboard",
    icon: <DashboardIcon />,
    navigateTo: "/admin/dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
  },
  {
    id: "DASHBOARD_SUPPLIER",
    title: "Dashboard Supplier",
    sideNavTitle: "Dashboard Supplier",
    icon: <DashboardIcon />,
    navigateTo: "/admin/supplier-dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: true,
  },
  {
    id: "USER_MANAGEMENT",
    title: "User Management",
    sideNavTitle: "User Management",
    icon: <GroupIcon />,
    navigateTo: "/admin/user-management",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "MASTER",
    title: "Master",
    sideNavTitle: "Master",
    icon: <AcUnitIcon />,
    navigateTo: "/admin/Category",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
    displayChildrenInSideNav: true,
    displayChildrenInGrid: false,
    children: [
      {
        id: "CATEGORY",
        title: "Category",
        sideNavTitle: "Category",
        icon: <CategoryIcon />,
        navigateTo: "/admin/category",
      },
      {
        id: "SUB_CATEGORY",
        title: "Sub Category",
        sideNavTitle: "Sub Category",
        icon: <CategoryIcon />,
        navigateTo: "/admin/sub-category",
      },
      {
        id: "ADDON",
        title: "Addon",
        sideNavTitle: "Addon",
        icon: <InventoryIcon />,
        navigateTo: "/admin/addon",
      },
      {
        id: "DELIVERY_FORMAT",
        title: "Delivery Format",
        sideNavTitle: "Delivery Format",
        icon: <InventoryIcon />,
        navigateTo: "/admin/deliveryformat",
      },
    ],
  },
  {
    id: "JOBS",
    title: "Jobs",
    sideNavTitle: "Jobs",
    icon: <StorageIcon />,
    navigateTo: "/admin/jobs",
    bgcolor: "#F0E5FF",
    color: "#3C008E",
    displayInSideNav: true,
    displayInGrid: false,
    displayChildrenInSideNav: true,
    displayChildrenInGrid: true,
    children: [
      {
        id: "TOTAL_JOBS",
        title: "Total Jobs",
        sideNavTitle: "Total Jobs",
        icon: <WorkIcon />,
        navigateTo: "/admin/jobs",
        bgcolor: "#F0E5FF",
        color: "#3C008E",
      },
      {
        id: "QUOTES",
        title: "Orders",
        sideNavTitle: "Orders",
        icon: <StorageIcon />,
        navigateTo: "/admin/jobs?status=2",
        bgcolor: "#E1E9FF",
        color: "#6993FF",
      },
      {
        id: "OPEN_ORDERS",
        title: "Open Orders",
        sideNavTitle: "Open Orders",
        icon: <StorageIcon />,
        navigateTo: "/jobs?status=3",
        bgcolor: "#E1F0FF",
        color: "#3392F3",
      },
      {
        id: "ARTWORK_APPROVALS",
        title: "Artwork Approvals",
        sideNavTitle: "Artwork Approvals",
        icon: <ApprovalIcon />,
        navigateTo: "/admin/jobs?status=5",
        bgcolor: "#EEE5FF",
        color: "#8950FC",
      },
      {
        id: "SAMPLE_APPROVALS",
        title: "Image File Approvals",
        sideNavTitle: "Image File Approvals",
        icon: <ApprovalIcon />,
        navigateTo: "/admin/jobs?status=7",
        bgcolor: "#F4E1F0",
        color: "#663259",
      },
      {
        id: "IN_PRODUCTION",
        title: "In Production",
        sideNavTitle: "In Production",
        icon: <ApprovalIcon />,
        navigateTo: "/admin/jobs?status=8",
        bgcolor: "#F4E1F0",
        color: "#663259",
      },
      {
        id: "DELIVERY_UNDERWAY",
        title: "Delivery Underway",
        sideNavTitle: "Delivery Underway",
        icon: <ApprovalIcon />,
        navigateTo: "/admin/jobs?status=9",
        bgcolor: "#F4E1F0",
        color: "#663259",
      },
      {
        id: "COMPLETED",
        title: "Completed",
        sideNavTitle: "Completed",
        icon: <CheckCircleIcon />,
        navigateTo: "/admin/jobs?status=10",
        bgcolor: "#DCF1EE",
        color: "#0BB783",
      },
    ],
  },
  {
    id: "PRODUCT",
    title: "Product",
    sideNavTitle: "Product",
    icon: <InventoryIcon />,
    navigateTo: "/admin/product",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "ARTWORK_PRODUCT",
    title: "Artwork Products",
    sideNavTitle: "Artwork Products",
    icon: <InventoryIcon />,
    navigateTo: "/admin/artwork-product",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "MY_PROFILE",
    title: "My Profile",
    sideNavTitle: "My Profile",
    icon: <AccountCircle />,
    navigateTo: "/admin/my-profile",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "LOGOUT",
    title: "Logout",
    sideNavTitle: "Logout",
    icon: <LogoutIcon />,
    onClickFunc: "logout",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
];

export const actionItems = [
  {
    id: "DASHBOARD",
    title: "Dashboard",
    sideNavTitle: "Dashboard",
    icon: <DashboardIcon />,
    navigateTo: "/dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
  },
  {
    id: "WEBSITE",
    title: "Website",
    sideNavTitle: "Website",
    icon: <LanguageIcon />,
    externalLink: "https://logopromo.com.au/my-account/",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "NEW_JOB",
    title: "New Job",
    sideNavTitle: "New Job",
    icon: <WorkIcon />,
    navigateTo: "/new-job",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: false,
    displayInGrid: false,
  },
  {
    id: "JOBS",
    title: "Jobs",
    sideNavTitle: "Jobs",
    icon: <StorageIcon />,
    navigateTo: "/jobs",
    bgcolor: "#F0E5FF",
    color: "#3C008E",
    displayInSideNav: true,
    displayInGrid: false,
    displayChildrenInSideNav: false,
    displayChildrenInGrid: true,
    children: [
      {
        id: "TOTAL_JOBS",
        title: "Total Jobs",
        sideNavTitle: "Total Jobs",
        icon: <WorkIcon />,
        navigateTo: "/jobs",
        bgcolor: "#F0E5FF",
        color: "#3C008E",
      },
      {
        id: "QUOTES",
        title: "Orders",
        sideNavTitle: "Orders",
        icon: <StorageIcon />,
        navigateTo: "/jobs?status=2",
        bgcolor: "#E1E9FF",
        color: "#6993FF",
      },
      {
        id: "OPEN_ORDERS",
        title: "Open Orders",
        sideNavTitle: "Open Orders",
        icon: <StorageIcon />,
        navigateTo: "/jobs?status=3",
        bgcolor: "#E1F0FF",
        color: "#3392F3",
      },
      {
        id: "ARTWORK_APPROVALS",
        title: "Artwork Approvals",
        sideNavTitle: "Artwork Approvals",
        icon: <ApprovalIcon />,
        navigateTo: "/jobs?status=5",
        bgcolor: "#EEE5FF",
        color: "#8950FC",
      },
      {
        id: "SAMPLE_APPROVALS",
        title: "Image File Approvals",
        sideNavTitle: "Image File Approvals",
        icon: <ApprovalIcon />,
        navigateTo: "/jobs?status=7",
        bgcolor: "#F4E1F0",
        color: "#663259",
      },
      {
        id: "COMPLETED",
        title: "Completed",
        sideNavTitle: "Completed",
        icon: <CheckCircleIcon />,
        navigateTo: "/jobs?status=8",
        bgcolor: "#DCF1EE",
        color: "#0BB783",
      },
    ],
  },
  {
    id: "PRODUCTS",
    title: "Products",
    sideNavTitle: "Products",
    icon: <InventoryIcon />,
    navigateTo: "/products",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "ARTWORK_PRICE_LIST",
    title: "Artworks",
    sideNavTitle: "Artworks",
    icon: <InventoryIcon />,
    navigateTo: "/artwork-price-list",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "MY_PROFILE",
    title: "My Profile",
    sideNavTitle: "My Profile",
    icon: <AccountCircle />,
    navigateTo: "/my-profile",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "LOGOUT",
    title: "Logout",
    sideNavTitle: "Logout",
    icon: <LogoutIcon />,
    onClickFunc: "logout",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
];

export const getActionItems = (idList, isAdminOrEmp, role) => {
  let finalActionItems = (isAdminOrEmp === 1 || role === 4) ? adminActionItems : actionItems;
  return finalActionItems.filter((action) => idList.includes(action.id));
};

export const getSidenavItems = (idList, isAdminOrEmp, role) => {
  let finalActionItems = (isAdminOrEmp === 1 || role === 4) ? adminActionItems : actionItems;

  let sidenavItems = [
    {
      ...finalActionItems[0],
      title: role === 2 ? (finalActionItems[0].sideNavTitle + " Client") : finalActionItems[0].sideNavTitle,
      sideNavTitle: role === 2 ? (finalActionItems[0].sideNavTitle + " Client") : finalActionItems[0].sideNavTitle,
    },
  ];

  finalActionItems.forEach((action) => {
    if (action.displayInSideNav && idList.includes(action.id)) {
      let sideNavItem = {
        ...action,
        title: action.sideNavTitle,
      };

      if (sideNavItem.children && !sideNavItem.displayChildrenInSideNav) {
        delete sideNavItem.children;
      }

      sidenavItems.push(sideNavItem);
    }
  });

  let userActionItems = finalActionItems.filter((item) => item.id === "MY_PROFILE" || item.id === "LOGOUT");

  userActionItems.forEach((uAction) => {
    sidenavItems.push(uAction);
  });

  return sidenavItems;
};
